import {call, put, takeLatest} from "redux-saga/effects";

import {
  addInventory,
  loadInventories,
  simDropdown,
  systemProfile,
  deleteInventory,
  toggleInventoryCommission,
} from "../AsyncActions/inventory.async";
import * as actions from "../action.constants";
import {suspendSim} from "../AsyncActions/sim.async";

function* inventoryListRequest(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const response = yield call(loadInventories, pageUrl);
    if (response) {
      yield put({
        type: actions.SAVE_INVENTORY_LIST,
        responsePayload: response?.data,
      });
    }
  } catch (e) {
    //Empty block
  }
}

function* addInventoryRequest(action = {}) {
  const {requestPayload = {}, callback = () => {}} = action;
  try {
    const response = yield call(addInventory, requestPayload);
    if (response) {
      yield callback();
    }
  } catch (e) {
    //Empty block
  }
}

function* simDropdownRequest() {
  try {
    const response = yield call(simDropdown);
    if (response?.data) {
      yield put({
        type: actions.SAVE_SIM_DROPDOWN_DATA,
        responsePayload: response?.data?.results,
      });
    }
  } catch (e) {
    //Empty block
  }
}

function* systemProfileRequest() {
  try {
    const response = yield call(systemProfile);
    if (response?.data) {
      yield put({
        type: actions.SAVE_SYSTEM_PROFILE_DATA,
        responsePayload: response?.data?.results,
      });
    }
  } catch (e) {
    //Empty block
  }
}

function* suspendInventorySimRequest(action = {}) {
  const {payload, callback = () => {}} = action;
  try {
    const response = yield call(suspendSim, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* deleteInventoryRequest(action = {}) {
  const {payload, callback = () => {}} = action;

  try {
    const response = yield call(deleteInventory, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

function* toggleInventoryCommissionRequest(action = {}) {
  const {payload, callback = () => {}} = action;
  try {
    const response = yield call(toggleInventoryCommission, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}

export function* inventorySaga() {
  yield takeLatest(actions.REQUEST_INVENTORY_LIST_SAGA, inventoryListRequest);
  yield takeLatest(actions.REQUEST_ADD_INVENTORY_SAGA, addInventoryRequest);
  yield takeLatest(actions.REQUEST_SIM_DROPDOWN_DATA, simDropdownRequest);
  yield takeLatest(actions.REQUEST_SYSTEM_PROFILE_DATA, systemProfileRequest);
  yield takeLatest(actions.REQUEST_DELETE_INVENTORY_SAGA, deleteInventoryRequest);
  yield takeLatest(
    actions.REQUEST_SUSPEND_INVENTORY_SIM_SAGA,
    suspendInventorySimRequest
  );
  yield takeLatest(
    actions.REQUEST_TOGGLE_INVENTORY_COMMISSION_SAGA,
    toggleInventoryCommissionRequest
  );
}
